// extracted by mini-css-extract-plugin
export default {"shareIcon":"share-menu-option-module__shareIcon___bVET9"};